package com.devi3east.bashbuddy.common.service

class AppConfigRepositoryImpl(
    private val api: AppConfigApi
) : AppConfigRepository {

    override suspend fun getApiConfig(): Result<AppConfigResponse> = try {
        val response = api.getAppConfig()
        Result.success(response)
    } catch (e: Exception) {
        Result.failure(e)
    }

}